<template>
  <div>
    <div class="prizes__carousel">
      <div class="prizes__carousel__dots">
        <div v-if="prizes[0].activeFrom !== ''" :class="['owl-dot']"><span></span>
          <div v-if ="(type === 'DAILY')" class="desc">{{ getDayofWeek(prizes[0]) }}<br>{{ getDateFormat(prizes[0].activeFrom,'D MMM') }}<div v-if="type !== 'DAILY'">{{ getDateFormat(prizes[0].activeTo,'D MMM') }}</div></div>
          <div v-else class="desc">{{ getDateFormat(prizes[0].activeFrom,'D MMM') }} - {{ getDateFormat(prizes[0].activeTo,'D MMM') }}</div>
        </div>
        <div v-if="prizes[1].activeFrom !== ''" :class="['owl-dot']"><span></span>
          <div v-if ="(type === 'DAILY')" class="desc">{{ getDayofWeek(prizes[1]) }}<br>{{ getDateFormat(prizes[1].activeFrom,'D MMM') }}<div v-if="type !== 'DAILY'">{{ getDateFormat(prizes[1].activeTo,'D MMM')  }}</div></div>
          <div v-else class="desc">{{ getDateFormat(prizes[1].activeFrom,'D MMM') }} - {{ getDateFormat(prizes[1].activeTo,'D MMM') }}</div>
        </div>
        <div v-if="prizes[2].activeFrom !== ''" :class="['owl-dot']"><span></span>
          <div v-if ="(type === 'DAILY')" class="desc">{{ getDayofWeek(prizes[2]) }}<br>{{ getDateFormat(prizes[2].activeFrom,'D MMM') }}</div>
          <div v-else class="desc">{{ getDateFormat(prizes[2].activeFrom,'D MMM') }} - {{ getDateFormat(prizes[2].activeTo,'D MMM') }}</div>
        </div>
      </div>
      <div :class="[(getNumberOfItems() !== 1)? 'owl-carousel' : '', 'prizes-carousel', 'generic-carousel']">
        <div class="item" v-if="prizes[0].imgUrl">
          <img :src="prizes[0].imgUrl" alt="">
          <span>{{ prizes[0].headline }}</span>
        </div>
        <div class="item" v-if="prizes[1].imgUrl">
          <img :src="prizes[1].imgUrl" alt="">
          <span>{{ prizes[1].headline }}</span>
        </div>
        <div class="item" v-if="getNumberOfItems() !== 1 && prizes[2].imgUrl">
          <img :src="prizes[2].imgUrl" alt="">
          <span>{{ prizes[2].headline }}</span>
        </div>
        <div v-else class="item">
          <img :src="prizes[2].imgUrl" alt="" @click="clickOnImage(prizes[2])">
          <span>{{ prizes[2].headline }}</span>
        </div>
      </div>
      <div class="carousel__nav"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'date-tab',
  props: ['type', 'getDateFormat', 'prizes', 'clickOnImage'],
  methods: {
    getDayofWeek(dayOfweek) {
      return this.getDateFormat(dayOfweek.activeFrom, 'ddd');
    },
    getNumberOfItems() {
      return this.prizes.filter(item => item.imgUrl).length;
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/prizesAndLeaderboards/DateTab.vue